import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const PageHeader = ({ title, subtitle, backLink, actionButton }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-8 relative">
      {/* Decorative background element for premium feel */}
      <div className="absolute -top-6 -left-6 w-32 h-32 bg-red-50 rounded-full mix-blend-multiply filter blur-2xl opacity-70 animate-pulse-slow -z-10"></div>
      
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6 relative z-10">
        <div className="flex items-center space-x-4">
          {backLink && (
            <button 
              onClick={() => navigate(backLink)}
              className="group flex items-center justify-center w-10 h-10 bg-white rounded-full shadow-[0_4px_14px_0_rgb(0,0,0,0.05)] border border-gray-100 hover:shadow-[0_6px_20px_rgba(220,38,38,0.12)] hover:border-red-100 transition-all duration-300 transform hover:-translate-x-1"
              title="Go Back"
            >
              <ArrowLeftIcon className="h-4 w-4 text-gray-500 group-hover:text-red-600 transition-colors" strokeWidth={2.5} />
            </button>
          )}
          
          <div className="flex flex-col">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight leading-none bg-clip-text">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm font-medium text-gray-500 mt-1.5 flex items-center">
                <span className="w-1.5 h-1.5 rounded-full bg-red-400 mr-2 opacity-80"></span>
                {subtitle}
              </p>
            )}
          </div>
        </div>
        
        {actionButton && (
          <div className="flex items-center">
            <div className="shadow-[0_4px_14px_0_rgb(0,0,0,0.05)] rounded-full hover:shadow-[0_6px_20px_rgba(220,38,38,0.2)] transition-shadow duration-300">
              {actionButton}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
